var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCommentNew = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5C0 5.87258 5.37258 0.5 12 0.5C18.6274 0.5 24 5.87258 24 12.5C24 19.1274 18.6274 24.5 12 24.5C5.37258 24.5 0 19.1274 0 12.5Z",
    fill: "#F5F7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 9.83341H16.6667C17.403 9.83341 18 10.4304 18 11.1667V15.1667C18 15.9031 17.403 16.5001 16.6667 16.5001H15.3333V19.1667L12.6667 16.5001H10C9.63181 16.5001 9.29848 16.3508 9.05719 16.1096M9.05719 16.1096L11.3333 13.8334H14C14.7364 13.8334 15.3333 13.2365 15.3333 12.5001V8.50008C15.3333 7.7637 14.7364 7.16675 14 7.16675H7.33333C6.59695 7.16675 6 7.7637 6 8.50008V12.5001C6 13.2365 6.59695 13.8334 7.33333 13.8334H8.66667V16.5001L9.05719 16.1096Z",
    stroke: "#2C2960",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCommentNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/commentNew.d791d96d.svg";
export { ForwardRef as ReactComponent };